import angular from "angular";

angular
    .module('app')
    .component('clientImportErrorMessages', {
        template: require('./client-import-error-messages.html'),
        controller: [controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller() {

    const $ctrl = this;

    $ctrl.$onInit = () => {
        $ctrl.client = $ctrl.resolve.client;
    };

}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/client-import-error-messages/client-import-error-messages.js